export default function lazyLoadImages(delay = 0) {
	setTimeout(() => {
		const targets = document.querySelectorAll('.lazy');
		// eslint-disable-next-line no-shadow
		const observer = new IntersectionObserver((entries, observer) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					const element = entry.target;
					if (element.tagName === 'PICTURE') {
						const img = element.querySelector('img');
						const source = element.querySelector('source');
						if (source && source.hasAttribute('data-srcset')) {
							source.srcset = source.getAttribute('data-srcset');
							source.removeAttribute('data-srcset');
						}
						if (img && img.hasAttribute('data-src')) {
							img.src = img.getAttribute('data-src');
							img.removeAttribute('data-src');
						}
						if (element.hasAttribute('data-class')) {
							element.classList.add(element.getAttribute('data-class'));
						}
						element.removeAttribute('data-class');
						element.classList.remove('lazy');
					} else {
						if (element.hasAttribute('data-class')) {
							element.classList.add(element.getAttribute('data-class'));
						}

						if (element.hasAttribute('data-srcset')) {
							element.setAttribute('srcset', element.getAttribute('data-srcset'));
						}

						if (element.hasAttribute('data-src')) {
							element.setAttribute('src', element.getAttribute('data-src'));
						}

						if (element.hasAttribute('data-href')) {
							element.setAttribute('href', element.getAttribute('data-href'));
						}

						element.removeAttribute('data-srcset');
						element.removeAttribute('data-src');
						element.removeAttribute('data-href');
						element.removeAttribute('data-class');
						element.classList.remove('lazy');
					}

					observer.unobserve(element);
				}
			});
		});

		targets.forEach((target) => observer.observe(target));
	}, delay);
}
